import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  error_toast_message,
  success_toast_message,
} from "../../utils/helper/toast_message";
import {
  asyncStatus,
  save_tokens_constant,
} from "../../utils/contants/asyncStatus";
import {
  add_category,
  add_user,
  block_ad,
  block_user,
  check_auth,
  delete_category,
  delete_user,
  get_all_ads,
  get_category,
  get_dashboard,
  get_users,
  get_vendor,
  login_service_auth,
  update_category,
  update_user,
} from "../services/authentication";

const initialState = {
  // status
  check_auth_status: asyncStatus.IDLE,
  user_login_status: asyncStatus.IDLE,
  user_logout_status: asyncStatus.IDLE,

  // data
  isAuthenticated: false,
  userAuth: false,
  user: null,

  authTokens: null,
  user_profile: null,
  profile_status: 0,
  role: "",

  // error
  check_auth_error: null,
  user_register_error: null,
  vendor_register_error: null,
  user_login_error: null,
  user_logout_error: null,

  get_users_data: [],
  get_users_status: asyncStatus.IDLE,
  get_users_error: null,

  get_vendor_data: [],
  get_vendor_status: asyncStatus.IDLE,
  get_vendor_error: null,


  get_category_data: [],
  get_category_status: asyncStatus.IDLE,
  get_category_error: null,


  add_category_data: [],
  add_category_status: asyncStatus.IDLE,
  add_category_error: null,


  update_category_data: [],
  update_category_status: asyncStatus.IDLE,
  update_category_error: null,


  delete_category_data: [],
  delete_category_status: asyncStatus.IDLE,
  delete_category_error: null,


  get_dashboard_data: [],
  get_dashboard_status: asyncStatus.IDLE,
  get_dashboard_error: null,

  get_all_ads_data: [],
  get_all_ads_status: asyncStatus.IDLE,
  get_all_ads_error: null,


  block_ad_data: [],
  block_ad_status: asyncStatus.IDLE,
  block_ad_error: null,


  block_user_data: [],
  block_user_status: asyncStatus.IDLE,
  block_user_error: null,


  delete_user_data: [],
  delete_user_status: asyncStatus.IDLE,
  delete_user_error: null,

  update_user_data: [],
  update_user_status: asyncStatus.IDLE,
  update_user_error: null,


  add_user_data: [],
  add_user_status: asyncStatus.IDLE,
  add_user_error: null,
};

const user_auth_slice = createSlice({
  name: "userAuth",
  initialState,

  reducers: {
    setIdleStatus(state) {
      state.user_logout_status = asyncStatus.IDLE;
    },
    setIdleRegisterStatus(state) {
      state.user_register_status = asyncStatus.IDLE;
    },
    setUserRole(state, { payload }) {
      state.role = payload;
    },
    // for only booking value change
    setpageValue(state, { payload }) {
      state.pageValue = payload;
    },
    setUserAuth(state, { payload }) {
      state.userAuth = payload;
    },
    // for only booking value change
  },
  extraReducers: (builder) => {
    builder.addCase(check_auth.pending, (state, action) => {
      state.check_auth_status = asyncStatus.LOADING;
    });

    builder.addCase(check_auth.fulfilled, (state, { payload }) => {
      // state.authTokens = payload.data.token;
      state.check_auth_status = asyncStatus.SUCCEEDED;
      state.user = payload.data;
      console.log("payload", payload);
      // state.userRole = payload.user.user_role;
      state.userAuth = true;
      state.check_auth_error = null;
    });

    builder.addCase(check_auth.rejected, (state, action) => {
      state.check_auth_status = asyncStatus.ERROR;
      state.check_auth_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    builder.addCase(login_service_auth.pending, (state, action) => {
      state.user_login_status = asyncStatus.LOADING;
    });

    builder.addCase(login_service_auth.fulfilled, (state, { payload }) => {
      state.isAuthenticated = true;
      state.authTokens = payload.tokens.access_token;
      state.user_login_status = asyncStatus.SUCCEEDED;
      state.user = payload.data;
      state.userAuth = true;
      success_toast_message("Login Successfully");
      state.user_login_error = null;
      console.log("payload", payload);
      localStorage.setItem(
        save_tokens_constant.AUTH,
        payload.tokens.access_token
      );
    });

    builder.addCase(login_service_auth.rejected, (state, action) => {
      state.user_login_status = asyncStatus.ERROR;
      state.user_login_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    // users========================
    builder.addCase(get_users.pending, (state, action) => {
      state.get_users_status = asyncStatus.LOADING;
    });

    builder.addCase(get_users.fulfilled, (state, { payload }) => {
      state.get_users_data = payload;
      state.get_users_error = null;
      state.get_users_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(get_users.rejected, (state, action) => {
      state.get_users_status = asyncStatus.ERROR;
      state.get_users_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    // vendor========================
    builder.addCase(get_vendor.pending, (state, action) => {
      state.get_vendor_status = asyncStatus.LOADING;
    });

    builder.addCase(get_vendor.fulfilled, (state, { payload }) => {
      state.get_vendor_data = payload;
      state.get_vendor_error = null;
      state.get_vendor_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(get_vendor.rejected, (state, action) => {
      state.get_vendor_status = asyncStatus.ERROR;
      state.get_vendor_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    // category========================
    builder.addCase(get_category.pending, (state, action) => {
      state.get_category_status = asyncStatus.LOADING;
    });

    builder.addCase(get_category.fulfilled, (state, { payload }) => {
      state.get_category_data = payload;
      state.get_category_error = null;
      state.get_category_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(get_category.rejected, (state, action) => {
      state.get_category_status = asyncStatus.ERROR;
      state.get_category_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // category addd========================
    builder.addCase(add_category.pending, (state, action) => {
      state.add_category_status = asyncStatus.LOADING;
    });

    builder.addCase(add_category.fulfilled, (state, { payload }) => {
      state.add_category_data = payload;
      state.add_category_error = null;
      state.add_category_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(add_category.rejected, (state, action) => {
      state.add_category_status = asyncStatus.ERROR;
      state.add_category_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // category update========================
    builder.addCase(update_category.pending, (state, action) => {
      state.update_category_status = asyncStatus.LOADING;
    });

    builder.addCase(update_category.fulfilled, (state, { payload }) => {
      state.update_category_data = payload;
      state.update_category_error = null;
      state.update_category_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(update_category.rejected, (state, action) => {
      state.update_category_status = asyncStatus.ERROR;
      state.update_category_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // category delete========================
    builder.addCase(delete_category.pending, (state, action) => {
      state.delete_category_status = asyncStatus.LOADING;
    });

    builder.addCase(delete_category.fulfilled, (state, { payload }) => {
      state.delete_category_data = payload;
      state.delete_category_error = null;
      state.delete_category_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(delete_category.rejected, (state, action) => {
      state.delete_category_status = asyncStatus.ERROR;
      state.delete_category_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // get_dashboard========================
    builder.addCase(get_dashboard.pending, (state, action) => {
      state.get_dashboard_status = asyncStatus.LOADING;
    });

    builder.addCase(get_dashboard.fulfilled, (state, { payload }) => {
      state.get_dashboard_data = payload;
      state.get_dashboard_error = null;
      state.get_dashboard_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(get_dashboard.rejected, (state, action) => {
      state.get_dashboard_status = asyncStatus.ERROR;
      state.get_dashboard_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // get_all_ads========================
    builder.addCase(get_all_ads.pending, (state, action) => {
      state.get_all_ads_status = asyncStatus.LOADING;
    });

    builder.addCase(get_all_ads.fulfilled, (state, { payload }) => {
      state.get_all_ads_data = payload;
      state.get_all_ads_error = null;
      state.get_all_ads_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(get_all_ads.rejected, (state, action) => {
      state.get_all_ads_status = asyncStatus.ERROR;
      state.get_all_ads_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    // block_ad========================
    builder.addCase(block_ad.pending, (state, action) => {
      state.block_ad_status = asyncStatus.LOADING;
    });

    builder.addCase(block_ad.fulfilled, (state, { payload }) => {
      state.block_ad_data = payload;
      state.block_ad_error = null;
      state.block_ad_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(block_ad.rejected, (state, action) => {
      state.block_ad_status = asyncStatus.ERROR;
      state.block_ad_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });

    // block_user========================
    builder.addCase(block_user.pending, (state, action) => {
      state.block_user_status = asyncStatus.LOADING;
    });

    builder.addCase(block_user.fulfilled, (state, { payload }) => {
      state.block_user_data = payload;
      state.block_user_error = null;
      state.block_user_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(block_user.rejected, (state, action) => {
      state.block_user_status = asyncStatus.ERROR;
      state.block_user_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // update_user========================
    builder.addCase(update_user.pending, (state, action) => {
      state.update_user_status = asyncStatus.LOADING;
    });

    builder.addCase(update_user.fulfilled, (state, { payload }) => {
      state.update_user_data = payload;
      state.update_user_error = null;
      state.update_user_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(update_user.rejected, (state, action) => {
      state.update_user_status = asyncStatus.ERROR;
      state.update_user_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // delete_user========================
    builder.addCase(delete_user.pending, (state, action) => {
      state.delete_user_status = asyncStatus.LOADING;
    });

    builder.addCase(delete_user.fulfilled, (state, { payload }) => {
      state.delete_user_data = payload;
      state.delete_user_error = null;
      state.delete_user_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(delete_user.rejected, (state, action) => {
      state.delete_user_status = asyncStatus.ERROR;
      state.delete_user_error = action.error;
      // console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
    // add_user========================
    builder.addCase(add_user.pending, (state, action) => {
      state.add_user_status = asyncStatus.LOADING;
    });

    builder.addCase(add_user.fulfilled, (state, { payload }) => {
      state.add_user_data = payload;
      state.add_user_error = null;
      state.add_user_status = asyncStatus.SUCCEEDED;
    });

    builder.addCase(add_user.rejected, (state, action) => {
      state.add_user_status = asyncStatus.ERROR;
      state.add_user_error = action.error;
      console.log("action.error",action.error.message);
      error_toast_message(action.error.message);
    });
  },
});

export const {
  setUserRole,
  setIdleStatus,
  setpageValue,
  setIdleRegisterStatus,
  setUserAuth,
} = user_auth_slice.actions;

export default user_auth_slice.reducer;
